import { render } from "./configuracoesView.vue?vue&type=template&id=37661030&scoped=true"
import script from "./configuracoesView.vue?vue&type=script&lang=js"
export * from "./configuracoesView.vue?vue&type=script&lang=js"

import "./configuracoesView.vue?vue&type=style&index=0&id=37661030&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37661030"]])

export default __exports__